import { defineNuxtPlugin } from '#app'
import { installApiTokenBridge } from '~/features/auth/lib/installApiTokenBridge'

/** Регистрирует до первых запросов useApi: обработка refresh без импортов features из shared/api */
export default defineNuxtPlugin({
  name: 'api-token-bridge',
  enforce: 'pre',
  setup() {
    installApiTokenBridge()
  },
})
